import https from './https'
import router from '@/router'

const partnerMarketing = {
  /**
   * Get available partner marketing exchange plans
   * @param {string} type - Type filter: 'serial' or 'product'
   */
  getAvailableRewards(type = null) {
    const orgCode = router.currentRoute.params.org_code
    const url = type 
      ? `${orgCode}/web/partner-marketing/?type=${type}`
      : `${orgCode}/web/partner-marketing/`
  return https.get(url)
  },

  /**
   * Get detailed information for a specific exchange plan
   */
  getRewardDetails(planId) {
    const orgCode = router.currentRoute.params.org_code
    return https.get(`${orgCode}/web/partner-marketing/${planId}`)
  },

  /**
   * Get user's available points for exchange
   */
  getUserPoints() {
    const orgCode = router.currentRoute.params.org_code
    return https.get(`${orgCode}/web/partner-marketing/user-points`)
  },

  /**
   * Get user exchange logs
   * @param {Object} filters - Filter parameters: type, period
   */
  getLogs(filters = {}) {
    const orgCode = router.currentRoute.params.org_code
    const params = new URLSearchParams(filters).toString()
    const url = params
      ? `${orgCode}/web/partner-marketing/logs?${params}`
      : `${orgCode}/web/partner-marketing/logs`
    return https.get(url)
  },

  /**
   * Redeem points for partner marketing codes
   * @param {string} planId - Partner marketing plan ID
   * @param {number} quantity - Number of codes to redeem
   */
  redeem(planId, quantity) {
    const orgCode = router.currentRoute.params.org_code
    return https.post(`${orgCode}/web/partner-marketing/redeem`, {
      plan_id: planId,
      quantity: quantity
    })
  },

  /**
   * Exchange serial code for Poya points
   * @param {string} serialNumber - Serial code to exchange
   */
  exchangeCodeForPoints(serialNumber) {
    const orgCode = router.currentRoute.params.org_code
    return https.post(`${orgCode}/web/partner-marketing/exchange-code`, {
      serial_number: serialNumber
    })
  },

  /**
   * Get POYA SSO URL for re-login
   */
  getSsoUrl() {
    const orgCode = router.currentRoute.params.org_code
    return https.get(`${orgCode}/web/partner-marketing/sso-url`)
  }
}

export default partnerMarketing
